import { Link } from "react-router-dom";
import { Carousel } from "flowbite-react";

const Article = () => {
  return (
    <div className="max-h-screen md:flex md:justify-end md:items-center overflow-hidden relative">
      <div className="article md:flex md:flex-row justify-center items-center h-screen w-[95%] relative">
        <div className="text-center md:z-20 relative sm:absolute top-0 right-0">
          <p className="mx-10 tracking-widest font-bold text-[50px] sm:text-[120px] animate__animated animate__slideInRight text-orangee">
            ARTICLES
          </p>
        </div>
        <div className="animate__animated animate__backInUp p-4 mx-2 my-2 overflow-hidden text-center">
          <p className="text-lg sm:text-3xl font-semibold text-orangee">
            You Guys Just Gotta Stay Tuned! It's Coming Very Soon!🥳🎉
          </p>
        </div>
      </div>
    </div>
  );
};

export default Article;
